import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NetworkAuthFull from './NetworkAuth';
import './NetworkAuth.css';

function NetworkAuth() {
  const [showSecretLogin, setShowSecretLogin] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isUnlocked, setIsUnlocked] = useState(false);

  const handleSecretLogin = (e) => {
    e.preventDefault();
    if (password === 'kevin') {
      setIsUnlocked(true);
      setShowSecretLogin(false);
    } else {
      setError('Invalid password');
      setTimeout(() => setError(''), 2000);
    }
  };

  // If unlocked, show the full NetworkAuth component
  if (isUnlocked) {
    return <NetworkAuthFull />;
  }

  return (
    <div className="network-auth-page">
      {/* Background */}
      <div className="auth-bg">
        <div className="auth-gradient"></div>
        <div className="auth-particles"></div>
      </div>

      {/* Coming Soon Content */}
      <div className="auth-container coming-soon-container">
        <img src="/logo.webp" alt="Alooma" className="coming-soon-logo" />
        <h1 className="auth-title">
          Alooma <span className="accent">Network</span>
        </h1>
        <div className="coming-soon-badge">Coming Soon</div>
        <p className="coming-soon-text">
          We're building something extraordinary. The Alooma Network will revolutionize 
          how brands and creators connect, collaborate, and create impact together.
        </p>
        <div className="coming-soon-features">
          <div className="feature-item">
            <span className="feature-number">01</span>
            <span>Direct Brand Partnerships</span>
          </div>
          <div className="feature-item">
            <span className="feature-number">02</span>
            <span>Transparent Bidding</span>
          </div>
          <div className="feature-item">
            <span className="feature-number">03</span>
            <span>Seamless Communication</span>
          </div>
        </div>
        <p className="coming-soon-cta-text">
          Stay tuned for an exciting update that will transform the creator economy.
        </p>
        <Link to="/" className="coming-soon-btn">
          ← Back to Alooma
        </Link>
      </div>

      {/* Secret Toggle Button */}
      <button 
        className="secret-toggle"
        onClick={() => setShowSecretLogin(!showSecretLogin)}
        aria-label="Admin access"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      </button>

      {/* Secret Login Modal */}
      {showSecretLogin && (
        <div className="secret-modal-overlay" onClick={() => setShowSecretLogin(false)}>
          <div className="secret-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Admin Access</h3>
            <form onSubmit={handleSecretLogin}>
              <input
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
              {error && <span className="secret-error">{error}</span>}
              <button type="submit">Unlock</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default NetworkAuth;



